import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyFormat' })
export class CurrencyFormatPipe implements PipeTransform {
    transform(amount: number | string, currency: string = 'ZAR'): string {
        if (amount == null) return '';

        // Convert string → number safely
        const numericAmount =
            typeof amount === 'string' ? Number.parseFloat(amount) : amount;

        if (Number.isNaN(numericAmount)) return '';

        let symbol = '';

        switch (currency) {
            case 'ZAR':
                symbol = 'R';
                break;
            case 'USD':
                symbol = '$';
                break;
            default:
                break;
        }

        return `${symbol} ${numericAmount.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
}
